<template>
  <v-card>
    <v-card-title class="text-h5">
      <!-- {{ title }} -->
      Upload PDS
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="8" class="mt-0 pt-0">
            <v-file-input
              color="deep-purple accent-4"
              counter
              label="File input"
              placeholder="Select your files"
              prepend-icon="mdi-paperclip"
              outlined
              @change="handleFileUpload"
              :show-size="1000"
              :disabled="submitted"
              accept=".csv"
            >
              <!-- <template v-slot:selection="{ index, text }">
                <v-chip
                  v-if="index < 2"
                  color="deep-purple accent-4"
                  dark
                  label
                  small
                >
                  {{ text }}
                </v-chip>

                <span
                  v-else-if="index === 2"
                  class="text-overline grey--text text--darken-3 mx-2"
                >
                  +{{ files.length - 2 }} File(s)
                </span>
              </template> -->
            </v-file-input>
          </v-col>

          <!-- <v-col cols="12" class="mt-0 pt-0">
                    <v-file-input
                      counter
                      show-size
                      label="Upload File*"
                      truncate-length="15"
                      prepend-icon=""
                      append-icon="mdi-image"
                      accept="image/*"
                      :rules="rules.required"
                      @change="handleImage"
                    ></v-file-input>
                  </v-col> -->
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions class="pb-5">
      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        @click="onSubmit()"
        :disabled="submitted"
        :loading="submitted"
        class="px-10"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
//import moment from "moment";
export default {
  data() {
    return {
      submitted: false,
      rules: {
        required: [(value) => !!value || "Required."],
        mobileNumberRules: [
          (value) => !!value || "Required",
          (value) => (value && value.length >= 16) || "Invalid mobile number",
        ],
        emailRules: [
          (v) => !!v || "Required",
          (v) =>
            /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) || "E-mail must be valid",
        ],
      },
      form: {
        file: "",
      },

      file: null,
      filename: "",
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    handleFileUpload(event) {
      console.log(event);
      if (!event) return;

      const file = event;

      console.log(file);
      this.file = file;
      this.filename = file.name;
    },
    async onSubmit() {
      // if (!this.$refs.form.validate()) {
      //           return false;
      //       }

      this.submitted = true;
      const formData = new FormData();
      formData.append("file", this.file);
      await this.$pds
        .post("/upload", formData)
        .then((response) => {
          const res = response.data;
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.submitted = false;

          if (res.status) {
            this.file = null;
            this.filename = "";
            // this.$refs.form.reset();
            // this.agree();
          }
        })
        .catch((e) => {
          console.log(e);
          this.submitted = false;
        });
    },
  },
};
</script>
